// extracted by mini-css-extract-plugin
module.exports = {"link":"home_link__2LSOs"};